import React, {useEffect, useState, Fragment} from 'react';
import flatstore from 'flatstore';
import Loader from '../../components/ui/Loader';
import Image from '../../components/ui/Image'
import parse from 'html-react-parser';
import LoadModules from '../../components/ui/LoadModules';
import {getFarmerInfo, getStaticPage} from '../../utils/services';
import {isArray, upperFirst, filter, includes} from 'lodash';
import {currentLang} from '../../utils/functions';
import bioland from '../../../src/assets/img/bio/organic-certification.svg'
import mscfish from '../../../src/assets/img/bio/certified-sustainable-seafood-by-msc.svg'
import NotFound from '../static/404';
import Meta from '../../components/ui/Meta';
import { useTranslation } from 'react-i18next';
import W from '../../components/ui/Word';
import {siteInfo} from './../../utils/config';


const FarmerDetail = ({slug, animal, loading, farmer_data, farmer_static, err_data}) => {
	const [data, setData] = useState(null);
	const [staticData, setStaticData] = useState(null)
	const [modules, setModules] = useState(0);
	const { t } = useTranslation();
	const animals = siteInfo[currentLang()]['animal_types'];
	let moduleData = {"relatedSlug":slug, "relatedType": "farmer"};
	let firstAnimalType = '';

	useEffect(() => {

		if (loading === false && slug) {
			if(slug == t('farmers.newfarmerslug')) // kalak rashti - Akbar should fix it later
				slug = 'nieuwe-boeren';
			getFarmerInfo(slug);
			getStaticPage(t('farmers.newfarmerslug'), 'farmer_static');
		}
		setData(farmer_data);

		if(farmer_data && farmer_data.modules !== null){
			setModules(farmer_data.modules);
		}

	}, [farmer_data]);

	useEffect(() => {
		if(farmer_static){
			setStaticData(farmer_static);
		}
	}, [farmer_static])

	if (typeof data !== 'undefined' && data !== null){
		if (!includes(animals,data.animal_types)){
			// If the farmer is new and has not sold animals yet, default animal-type to cow.
			firstAnimalType = 'cow';
			if (data.animal_types !== null && typeof data.animal_types !== 'undefined'){
				var allAnimalTypes = data.animal_types.split(',');
				firstAnimalType = allAnimalTypes[0];
			}
		} else {
			firstAnimalType = data.animal_types;
		}
	}

	if (loading) {
		return <Loader />
	} else {

		return (
			<Fragment>
				{!data && err_data && err_data == '404' &&
					<NotFound />
				}

			{data && isArray(data) &&
					<div className="container">
						{staticData &&
							<Meta
								title={staticData.seo_title ? staticData.seo_title : staticData.title}
								description={staticData.seo_description && staticData.seo_description}
								type="website"
                				image={staticData.image_url}
							/>
						}
						{staticData &&
							<div className="row">
								<div className="col-12 col-md-6 offset-md-3 pt-70">
									<h1 className="heading--h1">{staticData.title}</h1>
									{staticData &&
										<p>
											{parse(staticData.body)}
										</p>
									}
								</div>
							</div>
						}


						<div className="row row__spacing">
							{animals.map(animalItem=>{
								//console.log(animal, animalItem);
								if(animal && animal != t(animalItem)){
									return false;
								}
								var checkAnimal = filter(data, {"animal_types": animalItem});
								//console.log(checkAnimal);
								return (

									<Fragment>
									{checkAnimal && checkAnimal.length > 0 &&
										<div className="col-12 col-md-6 offset-md-3 new-farmers__title">
											<h3> <span className={"icon icon-cat-" + animalItem}></span> {t('datafilter.'+animalItem)}</h3>
										</div>
									}
									{data.map((item, index)=>{
										if(item.animal_types == animalItem){
											return (
												<div key={index} className="col-12 col-md-6 offset-md-3 new-farmers">
													<div className="new-farmers__img">
														<span className="icon-farmers"></span>
													</div>
													<div className="new-farmers__body">
														<h3 className="heading heading--h5">{item.title}</h3>
														{item.location && <div><strong><W>farmers.location</W></strong> {item.location}</div> }
														<div><strong><W>farmers.breeds</W>:</strong> {item.animal_breeds && item.animal_breeds.split(',').join(', ')}</div>
														{item.body && <p className="mb-0 text--black"> {parse(item.body)} </p>}
													</div>
												</div>
											)
										}
									})}
									</Fragment>
								)
							})}
						</div>
					</div>
			}
			{data && !isArray(data) &&
				<Fragment>
					<LoadModules modules={modules} moduleData={moduleData} type="top" />
					<Meta
						title={data.seo_title ? data.seo_title : data.title}
						description={data.seo_description && data.seo_description}
						type="website"
                		image={data.image_url}
					/>
					<div className="cover__farmer">
						<div className="container">
							<div className="row">
								<div className="col-12 body">
									<div className="farmer-user">
										<div className="avatar"><Image src={data.image_url} /></div>
										<div className="title">
											<div className="specs">
												<div className="location">
													<span className="icon-location"></span>
													{data.location}
												</div>
												{data.is_organic == 1 &&
													<div className="bio"><img src={bioland} /></div>
												}

												{data.is_msc == 1 &&
													<div className="msc"><img src={mscfish} /></div>

												}

											</div>
											<h1 className="heading heading--h1">{data.title}</h1>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="cover__bg">
							<div className="gradient"></div>
							<Image src={data.header_image_url} />
						</div>
					</div>
					<div className="container">
						<div className="row">
						<div className="col-12">
							<div className="farmer__body">
							<div className="desc__info bg--caramel text--black mb-20">
								<ul>
									{data.animal_types != 'game' &&
										<Fragment>
										<li className="fld"><W>farmers.{firstAnimalType}</W></li>
										<li className="val">{data.title}</li>
										</Fragment>
									}
									<li className="fld"><W>farmers.location</W></li>
									<li className="val">{data.location}</li>

									<li className="fld"><W>farmers.breeds</W></li>
									<li className="val">
										{data.breeds && data.breeds.map((item)=>{
											return <span>{item}</span>
										})}
									</li>
								</ul>
							</div>
							<div className="bio-label"></div>
							<div className="excerpt--full text--black"> {data.body && parse(data.body)} </div>
							</div>
						</div>
					</div>
					</div>
				</Fragment>
			}

			<LoadModules modules={modules} moduleData={moduleData} type="bottom" />


			</Fragment>
		)
	}
}

export default flatstore.connect(['loading', 'farmer_data', 'farmer_static', 'err_data'])(FarmerDetail);
